import { Alert, Toast } from "react-bootstrap";
import { CheckmarkBadge04Icon } from "../../assets/icons";
import { CircleAlert, CircleX, TriangleAlert } from "lucide-react";

const CustomToast = ({ toast, onClose }) => {
  const { message, variant } = toast;

  let Icon = null;

  switch (variant) {
    case "success":
      Icon = CheckmarkBadge04Icon;
      break;

    case "danger":
      Icon = CircleX;
      break;

    case "warning":
      Icon = TriangleAlert;
      break;

    case "info":
      Icon = CircleAlert;
      break;

    default:
      Icon = null;
  }

  return (
    <Toast
      show
      onClose={onClose}
      delay={2400}
      autohide
      className={`py-0`}
    >
      <Alert
        variant={variant}
        className="m-0 py-2 px-3"
      >
        <Alert.Heading className="fs-md lh-sm mb-0 fw-semibold d-flex align-items-center gap-2">
          {Icon && (
            <Icon size={18} />
          )}
          {message}
        </Alert.Heading>
      </Alert>
    </Toast>
  );
};

export default CustomToast;
